"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CruelWinterAbilityHandler = exports.CruelWinterActorAbilityFactory = exports.CruelWinterAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class CruelWinterAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CruelWinter;
        this.__typeName = "CruelWinter";
    }
}
exports.CruelWinterAbilityArgs = CruelWinterAbilityArgs;
let CruelWinterActorAbilityFactory = class CruelWinterActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CruelWinter", "OneEnemies", 2);
    }
};
CruelWinterActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CruelWinter")
], CruelWinterActorAbilityFactory);
exports.CruelWinterActorAbilityFactory = CruelWinterActorAbilityFactory;
let CruelWinterAbilityHandler = class CruelWinterAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId,
            projectileType: "IceShard",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Frost", 70)
            ],
            onHit: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FrostDamageImmunity, -25)
                });
            }
        });
    }
};
CruelWinterAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CruelWinter)
], CruelWinterAbilityHandler);
exports.CruelWinterAbilityHandler = CruelWinterAbilityHandler;
